(function ($, gsap) {
    function Next(next) {
        this.$next = $(next);
        this.$nextLabel = $(".visually-hidden", next),
        this.isVisible = true;
        this.$slides = $(".u-slide");
        this.$window = $(window);
        this.init();
    }

    $.extend(Next.prototype, {
        init: function () {
            var that = this;

            that.refresh();

            that.$window.scroll(function () {
                that.refresh();
            });

            that.$next.click(function (e) {
                e.preventDefault();
                that.scrollToNextSlide();
            });
        },
        scrollToNextSlide: function () {
            // Scroll 1px down to be sure that next slide is reached although rounding errors
            window.scrollBy(0, 1);

            var $nextSlide = this.getNextSlide();

            if (!$nextSlide) {
                return;
            }

            gsap.to(window, {
                scrollTo: {y: $nextSlide[0], autoKill: false},
                duration: 2
            });
        },
        getNextSlide: function () {
            var currentOffset = document.documentElement.scrollTop;

            for (var i = 0; i < this.$slides.length; i++) {
                if (currentOffset < $(this.$slides[i]).offset().top) {
                    return $(this.$slides[i]);
                }
            }

            return null;
        },
        updateNextContent: function ($nextSlide) {
            var nextSlideId = "#" + $nextSlide.attr("id");

            if (this.$next.attr("href") !== nextSlideId) {
                var nextSlideHeadline = $("h1, h2, h3, h4", $nextSlide).first().text();

                this.$next.attr("href", nextSlideId);
                this.$nextLabel.text(nextSlideHeadline);
            }
        },
        refresh: function () {
            var $nextSlide = this.getNextSlide();

            if ($nextSlide) {
                this.updateNextContent($nextSlide);

                if (!this.isVisible) {
                    this.isVisible = true;
                    this.$next.fadeIn();
                }
            } else {
                if (this.isVisible) {
                    this.isVisible = false;
                    this.$next.fadeOut();
                }
            }
        }
    });

    $(".u-next").each(function () {
        if (!$.data(this, 'next')) {
            $.data(this, 'next', new Next(this));
        }
    });
})(window.jQuery, window.gsap);
